import React from "react";
import WebPricingLanding from "../../components/Landing/WebPricingLanding";

const WebPricingLandingPage = ({ lang, prefix }) => {
  return <WebPricingLanding lang={lang} prefix={prefix} />;
};

export default WebPricingLandingPage;
